import React from "react";

interface CellProps {
  color: string;
  className?: string;
  value?: number;
  date?: string;
}

interface MonthProps {
  startDate: Date;
  index: number;
}

interface WeekDayProps {
  index: number;
}

const DayNames: { [key: number]: string } = {
  0: "Mon",
  1: "Tue",
  2: "Wed",
  3: "Thu",
  4: "Fri",
  5: "Sat",
  6: "Sun",
};

const Cell = ({ color, className, value, date }: CellProps) => {
  const style = {
    backgroundColor: color,
  };

  return (
    <div className={`timeline-cells-cell ${className}`} style={style}>
      {date && date > new Date().toISOString() ? <div className="dot">.</div> : null}
      <div className="tooltip">
        {date} {value}
      </div>
    </div>
  );
};

const Month = ({ startDate, index }: MonthProps) => {
  const date = new Date(startDate);
  date.setDate(date.getDate() + index * 7);
  const monthName = new Intl.DateTimeFormat("en-US", { month: "short" }).format(date);

  return <div className={`timeline-months-month ${monthName}`}>{monthName}</div>;
};

const WeekDay = ({ index }: WeekDayProps) => {
  return <div className="timeline-weekdays-weekday">{DayNames[index]}</div>;
};

export { Cell, Month, WeekDay };
